/**
 * O lugar da página quando o acesso à escola está restrito (Escola Inteligente dentro do
 * Logigate): a escola, o motivo que o servidor manda e os contactos de ajuda.
 */
import React from "react";
import { Building2, ShieldAlert } from "lucide-react";
import { Avatar, Cartao, Selo } from "@/Logigate/ui";
import { ContactosDeAjuda } from "@/Logigate/components/PlanoBloqueadoOverlay";

interface EscolaBloqueadaOverlayProps {
    escola: any;
    mensagem: string;
}

export default function EscolaBloqueadaOverlay({ escola, mensagem }: EscolaBloqueadaOverlayProps) {
    const nome: string = escola?.info?.nome || "Instituição";

    return (
        <div className="mx-auto w-full max-w-xl space-y-4 py-2 sm:py-8">
            <Cartao espaco="nenhum" className="overflow-hidden">
                <div className="flex flex-col items-center px-5 pb-7 pt-8 text-center sm:px-8">
                    <div className="relative">
                        <Avatar src={escola?.info?.foto_link} nome={nome} tamanho="xl" cor="orange" className="shadow-md ring-4 ring-white dark:ring-zinc-900">
                            <Building2 />
                        </Avatar>
                        <span className="absolute -bottom-1 -right-1 flex size-8 items-center justify-center rounded-full bg-orange-500 text-white ring-4 ring-white dark:ring-zinc-900">
                            <ShieldAlert className="size-4" aria-hidden />
                        </span>
                    </div>
                    <p className="mt-4 text-[15px] font-semibold text-zinc-900 dark:text-zinc-50">{nome}</p>
                    <p className="text-[13px] text-zinc-500 dark:text-zinc-400">Instituição de ensino</p>

                    <Selo cor="orange" tamanho="md" className="mt-5">
                        Acesso restrito
                    </Selo>
                    <h1 className="mt-3 text-xl font-semibold tracking-tight text-zinc-900 dark:text-zinc-50 sm:text-2xl">Acesso temporariamente restrito</h1>
                    {mensagem && <p className="mt-2 max-w-md text-sm leading-relaxed text-zinc-600 dark:text-zinc-300">{mensagem}</p>}
                </div>
            </Cartao>

            <ContactosDeAjuda />
        </div>
    );
}
